import React from "react";
import { dummyimage, green_icon, red_icon } from "../../assets/imgs";
import CancelIcon from "@mui/icons-material/Cancel";

const AlreadyComPopup = ({ setPopup, admindetails, locList }) => {
  const handleClosePopup = () => {
    setPopup(false);
    window.location.reload();
  };

  return (
    <div className="popup-design">
      <div className="popup">
        <div className="d-flex ac-jb">
          <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 primary ">
            Already linked with company
          </h2>
          <button
            onClick={() => {
              handleClosePopup();
            }}
            className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary cust-btn"
          >
            <CancelIcon />
          </button>
        </div>
        <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
          Primary Email ID<span className="text-danger">*</span>
        </h4>
        <div className="d-flex">
          <input
            type="email"
            className={`input-pop ps-2 w-100`}
            placeholder=" Email Address"
            name="email"
            value={admindetails?.email}
            // disabled={popup == "view" || popup == "edit" ? true : false}
            disabled
          />
        </div>
        <div className="d-flex ac-je mt-2 gap-2">
          <img
            src={admindetails?.is_email_verified ? green_icon : red_icon}
            className="redImg"
          />
          <p className="f2 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
            {admindetails?.is_email_verified ? "Verified" : "Not Verified"}
          </p>
        </div>
        <>
          <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
            Company Name<span className="text-danger">*</span>
          </h4>
          <input
            type="text"
            className={`input-pop ps-2 w-100 `}
            placeholder="Company Name"
            name="company_name"
            value={admindetails?.company?.name}
          />
          <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
            Company Code<span className="text-danger">*</span>
          </h4>
          <input
            type="text"
            className={`input-pop ps-2 w-100 `}
            placeholder="Company Code"
            name="company_code"
            value={admindetails?.company?.company_code}
          />
          <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
            Primary Person Name<span className="text-danger">*</span>
          </h4>
          <input
            type="text"
            className={`input-pop ps-2 w-100 `}
            placeholder="Primary Person Name"
            name="name"
            value={admindetails?.name}
          />
          <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
            Primary Mobile Number(Singapore)
            <span className="text-danger">*</span>
          </h4>
          <input
            type="number"
            className={`input-pop ps-2 w-100 `}
            placeholder="Primary Mobile Number(Singapore)"
            name="phone"
            value={admindetails?.phone}
          />
          <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
            Roles<span className="text-danger">*</span>
          </h4>

          <input
            name="role_id"
            readOnly
            value={"Company Manager"}
            className={`input-pop ps-2 w-100`}
          />

          <div>
            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 ">
              Location<span className="text-danger">*</span>
            </h4>
            <select
              name="location"
              value={admindetails?.company?.location}
              className={`input-pop ps-2 w-100 `}
            >
              <option>Select Location</option>
              {locList.map((item) => {
                return (
                  <option value={item?.id} key={item?.id}>
                    {item?.name}
                  </option>
                );
              })}
            </select>
            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 d-flex ac-js gap-1">
              Company Logo Upload{" "}
              <span className="text-danger fs-12">
                JPG, JPEG, PNG only | Max size: 5MB
              </span>
            </h4>
            <div className={`input-pop mb-2 w-100 d-flex ac-jb `}>
              <div className="position-relative w-100">
                <div className="d-flex ac-jc w-100">
                  <div>
                    <img
                      alt="not found"
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "10px",
                      }}
                      src={
                        admindetails?.company?.logo
                          ? admindetails?.company?.logo
                          : dummyimage
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* {error && !selectedImage && (
                    <p className="err">Upload Logo </p>
                  )} */}
            <h4 className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 d-flex ac-js gap-1">
              Profile Image Upload{" "}
              <span className="text-danger fs-12">
                JPG, JPEG, PNG only | Max size: 5MB
              </span>
            </h4>
            <div className={`input-pop mb-2 w-100 d-flex ac-jb `}>
              <div className="position-relative w-100">
                <div className="d-flex ac-jc w-100">
                  <div>
                    <img
                      alt="not found"
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "10px",
                      }}
                      src={
                        admindetails?.profile_image
                          ? admindetails?.profile_image
                          : dummyimage
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* {error && !selectedImage && (
                    <p className="err">Upload Logo </p>
                  )} */}
          </div>
          {/* </fieldset> */}

          <div className="d-flex ac-jc">
            <button
              onClick={() => {
                handleClosePopup();
              }}
              className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
            >
              Close
            </button>
          </div>
        </>
      </div>
      {/* </div> */}
    </div>
  );
};

export default AlreadyComPopup;
